import React, { useState } from 'react';
import styled from 'styled-components';

import Modal from '../Modal/Modal';
import { colors, HealtheraButton } from '../../healtheraComponents';

const AddNoteModal = ({ open, onRequestClose, onAddNote, user }) => {
  const { forename, surname } = user;

  const [text, setText] = useState('');

  const handleChangeText = e => {
    setText(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    onAddNote(text);
  };

  return (
    <Modal open={open} onRequestClose={onRequestClose}>
      <Container style={{ padding: '32px 48px' }}>
        <ModalTitle>
          {forename} {surname} - <ModalText>Add note</ModalText>
        </ModalTitle>
        <TextArea spellCheck={false} value={text} onChange={handleChangeText} />
        <Form onSubmit={handleSubmit}>
          <HealtheraButton
            type="submit"
            disabled={!text}
            fontweight="500"
            fontfamily="SFProRegular"
            padding="8px 16px"
            width="auto"
            height="35px"
          >
            Add note
          </HealtheraButton>
          <CancelButton type="submit" onClick={onRequestClose}>
            Cancel
          </CancelButton>
        </Form>
      </Container>
    </Modal>
  );
};

export default AddNoteModal;

const Container = styled.div`
  padding: 32px 48px;
`;

const TextArea = styled.textarea`
  background-color: ${colors.FADED_LIGHT};
  border: none;
  resize: none;
  border-radius: 8px;
  padding: 16px;
  color: #383847;
  width: 560px;
  box-sizing: border-box;
  height: 160px;
`;

const ModalTitle = styled.p`
  margin: 0;
  margin-bottom: 16px;
  color: ${colors.DARK};
`;

const ModalText = styled.span`
  color: ${colors.FADED};
`;

const CancelButton = styled.button`
  color: ${colors.HEALTHERA_GREEN};
  border: none;
  background: none;
  cursor: pointer;
  margin-top: 8px;
  font-size: 16px;
`;

const Form = styled.form`
  width: 109px;
  margin: 0 auto;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
`;
